import React, { useState } from 'react';
import { auth } from './firebase'; // Adjust the path as needed
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // State for loading status
  const navigate = useNavigate(); // Initialize useNavigate

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Reload user to get the latest verification status
      await user.reload(); // Reload the user to update the user object
      const updatedUser = auth.currentUser; // Get the updated user object

      // Check if email is verified
      if (!updatedUser.emailVerified) {
        setError('Please verify your email before logging in.'); // Inform user to verify email
        setLoading(false); // Set loading to false
        return;
      }

      // Navigate to the dashboard after successful login
      navigate('/softwarerequirements'); // Adjust the route as needed
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false); // Set loading to false
    }
  };

  const handleTest = () => {
    // Navigate to the registration page
    navigate('/register'); // Adjust the route as needed
  };

  return (
    <div style={styles.container}>
      <img src={require('./login.webp')} alt="Login Animation" style={styles.gif} /> {/* Add GIF here */}
      <h2 style={styles.title}>Login</h2>
      {error && <p style={styles.error}>{error}</p>}
      <form onSubmit={handleLogin} style={styles.form}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      <label onClick={handleTest} >
        <h5>Don't Have an Account? Sign Up</h5>
      </label>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'black',
    color: '#00FFFF',
  },
  gif: {
    width: '300px', // Adjust size as needed
    height: 'auto',
    marginBottom: '20px',
  },
  title: {
    marginBottom: '20px',
    fontSize: '2rem',
  },
  error: {
    color: 'red',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  input: {
    padding: '10px',
    margin: '5px',
    borderRadius: '5px',
    border: '1px solid #00FFFF',
    width: '300px',
    backgroundColor: 'white',
    color: 'black',
  },
  button: {
    backgroundColor: '#00FFFF',
    color: 'black',
    border: 'none',
    padding: '10px 20px',
    margin: '10px 0',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },
};

export default Login;
